var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:[
      'appearance-none shadow-sm py-2 px-2  border block w-full sm:text-sm border-gray-300 rounded-md',
      !!_vm.error ? 'border-red-500' : 'border-gray-300 focus:border-primary'
  ],domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')}}})}
var staticRenderFns = []

export { render, staticRenderFns }